const Log_BaseUrl = "http://localhost:5000";




export default Log_BaseUrl; 